var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      !!_vm.datos_personales && !!_vm.estado_vacacion
        ? _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "contenedor-datos-personales" },
                [
                  _c(
                    "div",
                    { staticClass: "sub-contenedor-datos-personales" },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "justify-center": "",
                            "align-center": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-avatar",
                                {
                                  attrs: {
                                    color: _vm.foto
                                      ? "#FFF"
                                      : "light-blue darken-4",
                                    size: "90"
                                  }
                                },
                                [
                                  _vm.foto
                                    ? _c("v-img", {
                                        attrs: {
                                          "aspect-ratio": 16 / 9,
                                          src: _vm.foto,
                                          "max-height": "200",
                                          "max-width": "200",
                                          "min-height": "75",
                                          "min-width": "75"
                                        },
                                        on: {
                                          error: function($event) {
                                            return _vm.handleImageError()
                                          }
                                        }
                                      })
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "white--text display-1"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.datos_personales.nombres.trim()[0] ||
                                                "-"
                                            )
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                _vm._l(_vm.atributos_persona, function(
                                  atributo,
                                  index
                                ) {
                                  return _c(
                                    "v-flex",
                                    {
                                      key: index,
                                      staticClass: "datos-persona",
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "justify-center": "",
                                            "align-center": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "titulo text-md-right text-xs-center",
                                              attrs: { xs12: "", md6: "" }
                                            },
                                            [_vm._v(_vm._s(atributo.label))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "contenido text-md-left text-xs-center",
                                              attrs: { xs12: "", md6: "" }
                                            },
                                            [_vm._v(_vm._s(atributo.value))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1 tabla-comprimida-light",
                    attrs: {
                      headers: _vm.headers_saldos,
                      items: _vm.l_saldos_vacaciones,
                      "hide-actions": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-right" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.item.periodo ==
                                        _vm.estado_vacacion.periodo
                                        ? "Saldo a ganar en el periodo " +
                                            (props.item.periodo - 1) +
                                            " - " +
                                            props.item.periodo
                                        : "Saldo periodo  adquirido " +
                                            (props.item.periodo - 1) +
                                            " - " +
                                            props.item.periodo
                                    ) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.dias_saldo))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.dias_programar))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.item.dias_saldo -
                                        props.item.dias_programar
                                    ) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-xs-center font-weight-bold"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        "Podrán ser programados desde el " +
                                          _vm
                                            .$moment(
                                              props.item.fecha_inicio_uso
                                            )
                                            .format("DD/MM/YYYY") +
                                          " al " +
                                          _vm
                                            .$moment(props.item.fecha_fin_uso)
                                            .format("DD/MM/YYYY")
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "footer-table",
                                    attrs: { colspan: "2" }
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          "Total días a programar de acuerdo a porcentaje (" +
                                            _vm.datos_programacion.porcentaje +
                                            "%)"
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-center title" },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.total_dias_programar))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticStyle: { height: "10px" } }, [
                                _c(
                                  "td",
                                  {
                                    staticClass: "caption",
                                    attrs: { colspan: "5" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          '*Los DÍAS NO PROGRAMADOS podrán ser utilizados a través de "Solicitud con Cargo a Vacación"'
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1461818902
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39eab545", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39eab545","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/components/DatosPersonalesProgramacion.vue
// module id = null
// module chunks = 